<template>
  <section
    class="w-full bg-neutral-700 dark:bg-neutral-800 text-white overflow-hidden relative flex"
  >
    <ContainerBasic class="relative">
      <img
        class="z-[1] object-fill w-[300px] lg:w-[200px] xl:w-[340px] max-w-none absolute top-1/2 -translate-y-[50%] opacity-[0.15] right-0 dark:opacity-[0.35]"
        src="~/assets/images/logomark-black.svg"
        alt=""
      />
      <div class="relative z-[2] flex flex-col items-center justify-center py-8 lg:py-16 xl:py-32">
        <!-- Breadcrumb -->
        <div class="w-full mb-6 flex items-center flex-wrap gap-2">
          <UBreadcrumb :links="breadcrumbLinks" :ui="breadcrumbUi" class="flex-shrink-0" />
        </div>

        <!-- Category/Page Title -->
        <h1
          class="w-full mb-0 text-4xl font-extrabold leading-none tracking-tight dark:text-white md:text-5xl lg:text-6xl"
        >
          {{ title }}
        </h1>

        <!-- Optional Description -->
        <p
          v-if="description"
          class="w-full mb-0 text-lg font-normal dark:text-gray-200 lg:text-xl mt-4"
        >
          {{ description }}
        </p>
      </div>
    </ContainerBasic>
  </section>
</template>

<script lang="ts" setup>
interface Props {
  title: string;
  description?: string;
  category?: string;
  showBlogLink?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showBlogLink: true,
});

// Build breadcrumb links based on props
const breadcrumbLinks = computed(() => {
  const links = [];

  // Always show link back to main blog
  if (props.showBlogLink) {
    links.push({
      label: 'Blog',
      to: '/articles',
      icon: 'i-heroicons-newspaper',
    });
  }

  // If category is provided, add it as current page
  if (props.category) {
    links.push({
      label: props.category,
      // No 'to' property makes it render as a span (current page)
    });
  }

  return links;
});

// Custom UI for breadcrumb to style it for the hero section
const breadcrumbUi = {
  wrapper: 'flex items-center gap-2 flex-nowrap',
  ol: 'flex items-center gap-2 flex-nowrap',
  li: 'flex items-center gap-2 flex-shrink-0',
  base: 'text-white/90 hover:text-white dark:text-white/90 dark:hover:text-white flex items-center gap-2',
  active: 'text-white font-semibold dark:text-white',
  inactive: 'text-white/80 hover:text-white dark:text-white/80 dark:hover:text-white',
  divider: {
    base: 'text-white/60 dark:text-white/60 flex-shrink-0',
  },
};
</script>
